import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import api from '../../api/axios';
import BaseModal from '../utils/BaseModal';
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/lottie/loading.json";

type Props = {
    open: boolean;
    assetId?: string;
    onClose: () => void;
};

const ItemScreenshotModal = ({open, assetId, onClose}: Props) => {
    const [loading, setLoading] = useState(false);
    const [screenshotUrl, setScreenshotUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!open || !assetId) {
            if (screenshotUrl) {
                URL.revokeObjectURL(screenshotUrl);
                setScreenshotUrl(null);
            }
            return;
        }

        let cancelled = false;
        let createdObjectUrl: string | null = null;
        setLoading(true);

        api
            .get(`/item/${assetId}/screenshot`, {
                params: {mode: 'both'},
                responseType: 'blob',
            })
            .then((res) => {
                if (cancelled) return;
                createdObjectUrl = URL.createObjectURL(res.data);
                setScreenshotUrl(createdObjectUrl);
            })
            .catch(() => {
                if (!cancelled) {
                    toast.error('Failed to load screenshot');
                    onClose();
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
            if (createdObjectUrl) {
                URL.revokeObjectURL(createdObjectUrl);
            }
        };
    }, [open, assetId]);

    let content;
    if (loading) {
        content = (
            <div
                className="w-full min-h-[300px] max-h-[82vh] rounded-lg items-center justify-center p-1 bg-neutral-800">
                <Lottie animationData={loadingAnimation} loop className="w-82"/>
            </div>
        );
    } else if (screenshotUrl) {
        content = (
            <div className="flex justify-center items-center w-full overflow-hidden rounded-lg bg-neutral-800">
                <img
                    src={screenshotUrl}
                    alt={`Screenshot for ${assetId}`}
                    className="max-h-[80vh] max-w-full w-auto h-auto object-contain"
                />
            </div>
        );
    }

    return (
        <BaseModal open={open} onAbort={onClose} maxWidth="lg">
            <div className="w-full min-h-[300px] max-h-[82vh] flex items-center justify-center p-1">
                {content}
            </div>
        </BaseModal>
    );
};

export default ItemScreenshotModal;
